/**
 * Whether the "Continue now" support action should be offered for a workflow
 * event: only for a pending timer node, when the current user has permission,
 * and never for a superseded (soft-deleted) event.
 */
export const canContinueTimerNode = (
  event: { type: string; nodeId?: string | null; deletedAt?: string | null },
  hasPermission: boolean,
): boolean => {
  const eventType = event.type.split(":")[1] || event.type;
  return (
    hasPermission &&
    eventType === "pending" &&
    !!event.nodeId &&
    event.nodeId.startsWith("timer:") &&
    !event.deletedAt
  );
};
